module.exports = __webpack_public_path__ + "img/virtual-icon-modal.908c80ca.svg";